// extracted by mini-css-extract-plugin
module.exports = {"BannerA":"BannerA_BannerA__d8PZq"};